export default "__VITE_ASSET__EjDkFfkK__"